<overlay-header>
  <div>   
    <div [ngSwitch]="config.ViewMode">
      <div *ngSwitchCase="'template'">Template Editor</div>
      <div *ngSwitchCase="'page'">Design Page Editor</div>
      <div *ngSwitchCase="'customPage'">Custom Page Editor</div>
      <div *ngSwitchCase="'frma'">{{config.Title}}</div>
      <div *ngSwitchDefault>e-Form Editor</div> 
    </div>    
  </div>
  <div style="float:right;margin-right:-50px; margin-top: -35px;">
    <div>
      {{config.ViewMode == 'frma' ? '' : config.Title}}
    </div>
  </div>
</overlay-header>
<div *ngIf="config.InformationalMessage" class="infoMessage">{{config.InformationalMessage}}</div>
<mat-dialog-content style='padding-bottom: 0px !important;'>
  <div class="row" style="flex:1;height:100%; overflow:hidden;">
    <div class="col" style="flex:1;width:700px;">
      <e-form-header [config]="config" *ngIf="config.ShowHeader"></e-form-header>
      <tabs [tabNames]="tabNames" [transformLabelsToTitleCase]="false" (tabChange)="tabClick($event)" (click)="setFocusOnTabClick()" *ngIf="config.AllowTabs"></tabs>      
      <div style="display: flex;height: 40px; padding-top: 10px;"  *ngIf="config.AllowPages">
        <div style="width: 50%;">
          {{selectedPage.Name}}
        </div>
        <div style="width: 50%;text-align: end;padding-right: 20px;">
          Page {{selectedPageNumber}} of {{selectedTab.Pages.length}}
        </div>
      </div>
      <div class="row" style="flex:1;padding-top:20px;overflow:auto" [ngClass]="{'selected': tabSelected, 'dynamicWidth': config.IsDynamicWidth}">
        <div class="row eFormDesigner dropList" *ngIf="selectedPage"
              [ngClass]="{'selected': pageSelected, 'designPage': config.ViewMode == 'page' || config.ViewMode == 'customPage' || config.ViewMode == 'frma'}" cdkDropList [cdkDropListData]="selectedPage.Columns" (cdkDropListDropped)="columnDropped($event)" 
              cdkDropListOrientation="horizontal" [cdkDropListEnterPredicate]="columnPredicate">
            <e-form-column *ngFor="let column of selectedPage.Columns" [column]="column" [config]="config"
            (columnClickEvent)="columnClick(column)" class="dropItem eFormColumn" cdkDragLockAxis="x" cdkDrag [ngClass]="{'fixedWidth': column.FixedWidth}"
            cdkDragBoundary=".dropList" (cdkDragStarted)="dragStart()" (cdkDragEnded)="dragEnd()" [ngStyle]="{'width': column.FixedWidth ? (column.Width + 'px') : ''}">
            <button mat-icon-button cdkDragHandle style="cursor:move;">
              <img id='imgGrip' alt='Drag to Reorder' aria-label='Drag to Reorder' src='./assets/images/grip.png' *ngIf="selectedPage.Columns.length > 1"/>
            </button>
          </e-form-column>
        </div>
        <div id='filler' class="filler"></div>
      </div>
    </div>    
    <e-form-side-panel [(showSlideOutPanel)]="showSlideOutPanel" [config]="config" style="display:flex;overflow:hidden;"></e-form-side-panel>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>
    <tyl-button image="previous arrow.png" disabledImage="previous arrow disabled.png" label="Previous"
      (clickEvent)="previousClick()" [disabled]="isFP" *ngIf="config.AllowTabs || config.AllowPages"></tyl-button>
    <tyl-button image="import.png" label="Display Merge Fields" (clickEvent)="displayMergeFields()"></tyl-button>
    <tyl-button image="preview.png" label="Preview" (clickEvent)="previewClick()"></tyl-button>
    <tyl-button image="mobile.png" label="Mobile Preview" (clickEvent)="mobilePreviewClick()" *ngIf="config.IsMobile"></tyl-button>
    <tyl-checkbox id='chkShowBasePage' name='chkShowBasePage' [(checked)]='overwriteBasePage' *ngIf="showBasePageCB"
                    style="padding-left: 20px;">
                    Overwrite base page
    </tyl-checkbox>
  </div>
  <div class="flex-footer-middle">
    <tyl-button image="add.png" label="Add Tab" (clickEvent)="addTabClick()" *ngIf="config.AllowTabs"></tyl-button>
    <tyl-button image="add page.png" label="Add Page" (clickEvent)="addPageClick()" *ngIf="config.ViewMode != 'customPage' && config.AllowPages"></tyl-button>
    <tyl-button image="add column.png" disabledImage="add column disabled.png" label="Add Column" (clickEvent)="addColumnClick()" *ngIf="!config.IsMobile"></tyl-button>
    <tyl-button image="add row.png" disabledImage="add row disabled.png" label="Add Row" (clickEvent)="addRowClick()"></tyl-button>
  </div>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="next arrow.png" disabledImage="next arrow disabled.png" label="Next" (clickEvent)="nextClick()"
      [disabled]="isLP"  *ngIf="config.AllowTabs || config.AllowPages"></tyl-button>
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick(false)"></tyl-button>
    <tyl-button image="save.png" label="Save and Close" (clickEvent)="checkForWarnings()"></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>
